import type { FlowNodeResultADT } from '@lighthouse/shared'
import { t } from 'i18next'

export const handleOpenWechatLocation = async (): Promise<undefined | FlowNodeResultADT> => {
    // throw new Error('不能在搭建端使微信打开位置，请在发布后或预览版中使用。')
    throw new Error(t('cannotWechatOpenLocation'))
}
